// 引入 axios
import axios from 'axios'
import store from '@/store'




// 封装 baseURL
const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL
})
request.interceptors.request.use(async function (config) {
    config.headers['satoken'] = store.getters.saToken
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 向外暴露 request
export default request;